export function downloadFromUrl(url) {
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = '';
    downloadLink.style.display = 'none';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
}
